import HttpClient, { IResponseModel } from "../HttpClient";

import { IParentOrganization } from "@tedivo/tvd-api-models";

const urlParentOrganizations = "parent-organizations";

const ParentOrganizationsService = {
  adminGetAllParentOrgs: async (): Promise<
    IResponseModel<IParentOrganization[]>
  > => {
    const client = new HttpClient();
    return await client.request<IParentOrganization[]>({
      method: "GET",
      url: urlParentOrganizations,
    });
  },

  adminGetParentOrg: async (
    orgId: string,
  ): Promise<IResponseModel<IParentOrganization>> => {
    const client = new HttpClient();
    return await client.request<IParentOrganization>({
      method: "GET",
      url: `${urlParentOrganizations}/${orgId}`,
    });
  },

  adminCreateParentOrganization: async (
    data: Omit<IParentOrganization, "parentOrganizationId">,
  ): Promise<IResponseModel<ICreateOutput>> => {
    const client = new HttpClient();
    return await client.request<ICreateOutput>({
      method: "PUT",
      url: urlParentOrganizations,
      data,
    });
  },

  adminUpdateParentOrganization: async (
    data: IParentOrganization,
  ): Promise<IResponseModel<unknown>> => {
    const client = new HttpClient();
    return await client.request<unknown>({
      method: "PUT",
      url: urlParentOrganizations,
      data,
    });
  },

  adminDeleteParentOrganization: async (
    id: string,
  ): Promise<IResponseModel<unknown>> => {
    const client = new HttpClient();
    return await client.request<unknown>({
      method: "DELETE",
      url: `${urlParentOrganizations}/${id}`,
      data: undefined,
    });
  },
};

export default ParentOrganizationsService;

type ICreateOutput = { id: string; merged?: boolean };
